<a href="#main-content" class="sr-only focus:not-sr-only">Salta al contenuto principale</a>
<header class="bg-primary-blue fixed t-0 left-0 right-0 z-50 py-4 px-3.5 border-b border-white/5">
  <div class="grid grid-cols-3 items-center justify-items-center">
    <div class="col-start-2">
      <img
        src="assets/img/Polizia-di-Stato---logo-2025v2-(white).png"
        alt="Logo Polizia di Stato"
        class="h-8 w-auto"
      />
    </div>
    <div [ngClass]="isOpenSidebar() ? 'col-start-3' : ''" class="justify-self-end self-center">
      <button
        type="button"
        [attr.aria-label]="isOpenSidebar() ? 'Chiudi menu' : 'Apri menu'"
        aria-haspopup="true"
        [attr.aria-expanded]="isOpenSidebar()"
        aria-controls="main-menu"
        (click)="openSidebar()"
      >
        @if (!isOpenSidebar()) {
        <app-icon iconName="menu" stroke="white" className="w-6 h-6" aria-hidden="true" />
        } @else {
        <app-icon iconName="close" stroke="white" className="w-6 h-6" aria-hidden="true" />
        }
      </button>
    </div>
  </div>
</header>
@if (isOpenSidebar()) {
<div class="bg-primary-blue w-full min-h-screen flex flex-col" id="main-menu">
  <div class="px-4">
    <div class="pt-16">
      <div class="py-6 flex items-end">
        @if (user() == null) {
        <button
          class="bg-white/10 rounded-md w-full flex items-center justify-between cursor-pointer"
          (click)="goToLogin()"
        >
          <p class="text-white p y-6 px-8 font-regular">Area Personale</p>
          <div class="flex">
            <app-divider borderColor="border-white/10" height="h-full" />
            <div class="flex items-center justify-center px-7 py-5">
              <app-icon [iconName]="'lock'" stroke="white" className="w-6 h-6" />
            </div>
          </div>
        </button>
        } @else {
        <div class="flex flex-col w-full gap-0">
          <button
            class="bg-white/10 w-full flex items-center justify-between cursor-pointer"
            [class.rounded-md]="!isMenuOpen()"
            [class.rounded-t-md]="isMenuOpen()"
            (click)="openMenu()"
          >
            <p class="text-white p y-6 px-8 font-regular">Area Personale</p>
            <div class="flex">
              <app-divider borderColor="border-white/10" height="h-full" />
              <div class="flex items-center justify-center px-7 py-5">
                <app-icon
                  iconName="chevronDown"
                  [className]="isMenuOpen() ? 'rotate-180' : ''"
                  stroke="white"
                  className="w-6 h-6"
                />
              </div>
            </div>
          </button>
          @if (isMenuOpen()) {
          <app-divider
            borderColor="border-white/20 border-0 border-t-2"
            width="w-full"
            [isOrizontalDivider]="true"
          />
          <ul class="flex flex-col">
            <button
              class="bg-white/10 rounded-b-md w-full flex items-center justify-between cursor-pointer"
              (click)="logout()"
            >
              <p class="text-white p y-6 px-8 font-regular">Esci</p>
              <div class="flex">
                <div class="flex items-center justify-center px-7 py-7"></div>
              </div>
            </button>
          </ul>
          }
        </div>
        }
      </div>
    </div>
    <app-divider [isOrizontalDivider]="true" borderColor="border-white/10 w-full" />
    <div class="flex justify-between items-center py-5 px-3">
      <a
        href="https://www.facebook.com/poliziadistato.it?fref=ts"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Facebook Polizia di Stato (apre in una nuova scheda)"
        ><app-icon
          iconName="facebookLogo"
          stroke="none"
          fill="white"
          className="w-6 h-6"
          aria-hidden="true"
      /></a>
      <a
        href="https://x.com/poliziadistato"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="X Polizia di Stato (apre in una nuova scheda)"
        ><app-icon
          iconName="twitterLogo"
          stroke="none"
          fill="white"
          className="w-6 h-6"
          aria-hidden="true"
      /></a>
      <a
        href="https://www.youtube.com/user/poliziadistato"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="YouTube Polizia di Stato (apre in una nuova scheda)"
        ><app-icon
          iconName="youtubeLogo"
          stroke="none"
          fill="white"
          className="w-6 h-6"
          aria-hidden="true"
      /></a>
      <a
        href="https://www.instagram.com/poliziadistato/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Instagram Polizia di Stato (apre in una nuova scheda)"
        ><app-icon
          iconName="instagramLogo"
          stroke="none"
          fill="white"
          className="w-6 h-6"
          aria-hidden="true"
      /></a>
      <a
        href="https://t.me/poliziadistato"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Telegram Polizia di Stato (apre in una nuova scheda)"
      >
        <app-icon
          iconName="telegramLogo"
          stroke="none"
          fill="white"
          className="w-6 h-6"
          aria-hidden="true"
      /></a>
    </div>
  </div>

  <div class="grow"></div>
  <div class="w-full bg-mobile-footer text-white">
    <!--     <div class="py-5 px-4 border-b-2 border-b-white/10">
      <div class="flex justify-center">
        <div class="relative">
          <button (click)="isOpen.set(!isOpen())" [ngClass]="{'text-text-hover': isOpen()}"
            class="text-white text-sm flex items-center justify-center">
            <div class="flex items-center gap-4">
              <p class="font-regular">Cambia lingua</p>
              <app-divider />
              <div class="flex items-center justify-center">
                <p class="font-semi-bold uppercase">ITA</p>
                <app-icon iconName="chevronDown" stroke="white" [class.rotate-180]="isOpen()"
                  class="content-center items-center w-6 h-6" />
              </div>
            </div>
          </button>
          @if(isOpen()) {
          <div class="absolute flex top-full right-0 mt-2 bg-white/25 border-gray-200 shadow-lg py-2 z-50">
            <button class="block px-2 text-white hover:bg-gray-100">ITA</button>
            <button class="block px-2 text-white hover:bg-gray-100">ENG</button>
          </div>
          }
        </div>
      </div>
    </div>
 -->
    <div class="flex items-center justify-center py-2 sm:px-4 px-2">
      <div class="flex items-center justify-center w-full gap-2 sm:gap-1 py-10">
        <div class="flex xs:flex-row flex-col items-center gap-y-2">
          <div class="flex items-center">
            <app-icon iconName="italianFlag" className="pr-2" aria-hidden="true" />
            <p class="font-regular text-xs">Ministero dell'interno</p>
            <div class="px-1">
              <app-divider />
            </div>
          </div>
          <p class="font-regular text-xs">Dipartimento della Pubblica Sicurezza</p>
        </div>
      </div>
    </div>
  </div>
</div>
}
